{
  "app-frame": {
    "buttons": {
      "be-partner": "Für Saloninhaber",
      "login": "Anmelden",
      "logout": "Ausloggen",
      "my-appointments": "Meine Termine",
      "my-salons": "Meine Salons",
      "profile": "Profil",
      "read": "Lesen",
      "sign-up": "Registrieren",
      "top-salons": "Top Salons"
    },
    "text": {
      "agb-short": "AGB",
      "agb-updated-valid-since": "wurde aktualisiert und wird ab {{date}} gültig sein",
      "click-to-read": "Klicken zum Lesen"
    }
  }
}
